import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { referenceImagesSelector } from 'apps/formsCreationKit/store/selectors/referenceImages'
import {
  LabelInput,
  EntryTypeSelect,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel' 

const StaticImageReferenceImageSelect = {
  label: 'Reference Image',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'summary_entry_id',
  dynamicChoices: () => {
    const referenceImages = useSelector(referenceImagesSelector) || []
    const options = useMemo(() => {
      return [{ value: '', label: 'None' }].concat(
        referenceImages
          .map(({ id, name }) => ({ value: id, label: name }))
          .sort((a, b) => a.label.localeCompare(b.label))
      )
    }, [referenceImages])

    return options
  },
}

export const StaticImageStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  StaticImageReferenceImageSelect,
  HideOnPdfToggle,
]
